// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/QuickReactionsRow.module.css';
import type {FlatEmoji} from '@app/features/emoji/types/EmojiTypes';
import {shouldUseNativeEmoji} from '@app/features/expressions/utils/EmojiUtils';
import {getEmojiDisplayData} from '@app/features/expressions/utils/SkinToneUtils';
import * as AvatarUtils from '@app/features/user/utils/AvatarUtils';
import type React from 'react';
export function renderQuickReactionEmoji(emoji: FlatEmoji): React.ReactNode {
	const isUnicodeEmoji = !emoji.guildId && !emoji.id;
	const useNativeRendering = shouldUseNativeEmoji && isUnicodeEmoji;
	const {surrogates: displaySurrogates, url: displayUrl} = getEmojiDisplayData(emoji);
	if (useNativeRendering) {
		return <span className={styles.emojiNative}>{displaySurrogates}</span>;
	}
	const emojiSrc = emoji.id ? AvatarUtils.getEmojiURL({id: emoji.id, animated: false}) : (displayUrl ?? '');
	return <img src={emojiSrc} alt={emoji.name} className={styles.emojiImg} />;
}
